import {Injectable} from '@angular/core';
import {Observable, Subscriber} from 'rxjs';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Invoice} from '../../models/accounting/invoice';
import {AuthService} from '../auth/auth.service';
import {UploadFile} from '../../models/upload-file';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends AbstractModelService<Invoice> {
  constructor(apiClient: ApiClientService, private authService: AuthService) {
    super(apiClient, '/invoice', Invoice);
  }

  getDownloadPdfUrl(id: number): string {
    return this.apiClient.getUrl(this.routePath + '/' + id + '/download', {token: this.authService.getBearer()});
  }

  getInvoiceFile(id: number): Observable<Blob> {
    return this.apiClient.download(this.routePath + '/' + id + '/invoice-file');
  }

  updateInvoiceFile(id: number, uploadFile: UploadFile): Observable<void> {
    return this.update(id, {
      invoiceFile: {
        filename: String(uploadFile.filename).replace(/[\\/%]/g, '-'),
        data: uploadFile.data
      }
    });
  }

  recalculate(id: number): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<void>): void => {
      this.apiClient.post(this.routePath + '/' + id + '/recalculate').subscribe({
        next: () => {
          subscriber.next();
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  getDownloadUrl(invoiceId: number[], mode: 'csv' | 'zip'): string | null {
    if (!invoiceId.length) {
      return null;
    }

    return this.apiClient.getUrl(this.routePath + '/download', {invoiceId, mode, token: this.authService.getBearer()});
  }
}
